
import iosAddCircleOutline from './ios-add-circle-outline.svg';
import iosAddCircle from './ios-add-circle.svg';
import iosAdd from './ios-add.svg';
import iosAirplane from './ios-airplane.svg';
import iosAlarm from './ios-alarm.svg';
import iosAlbums from './ios-albums.svg';
import iosAlert from './ios-alert.svg';
import iosAmericanFootball from './ios-american-football.svg';
import iosAnalytics from './ios-analytics.svg';
import iosAperture from './ios-aperture.svg';
import iosApps from './ios-apps.svg';
import iosAppstore from './ios-appstore.svg';
import iosArchive from './ios-archive.svg';
import iosArrowBack from './ios-arrow-back.svg';
import iosArrowDown from './ios-arrow-down.svg';
import iosArrowDropdownCircle from './ios-arrow-dropdown-circle.svg';
import iosArrowDropdown from './ios-arrow-dropdown.svg';
import iosArrowDropleftCircle from './ios-arrow-dropleft-circle.svg';
import iosArrowDropleft from './ios-arrow-dropleft.svg';
import iosArrowDroprightCircle from './ios-arrow-dropright-circle.svg';
import iosArrowDropright from './ios-arrow-dropright.svg';
import iosArrowDropupCircle from './ios-arrow-dropup-circle.svg';
import iosArrowDropup from './ios-arrow-dropup.svg';
import iosArrowForward from './ios-arrow-forward.svg';
import iosArrowRoundBack from './ios-arrow-round-back.svg';
import iosArrowRoundDown from './ios-arrow-round-down.svg';
import iosArrowRoundForward from './ios-arrow-round-forward.svg';
import iosArrowRoundUp from './ios-arrow-round-up.svg';
import iosArrowUp from './ios-arrow-up.svg';
import iosAt from './ios-at.svg';
import iosAttach from './ios-attach.svg';
import iosBackspace from './ios-backspace.svg';
import iosBarcode from './ios-barcode.svg';
import iosBaseball from './ios-baseball.svg';
import iosBasket from './ios-basket.svg';
import iosBasketball from './ios-basketball.svg';
import iosBatteryCharging from './ios-battery-charging.svg';
import iosBatteryDead from './ios-battery-dead.svg';
import iosBatteryFull from './ios-battery-full.svg';
import iosBeaker from './ios-beaker.svg';
import iosBed from './ios-bed.svg';
import iosBeer from './ios-beer.svg';
import iosBicycle from './ios-bicycle.svg';
import iosBluetooth from './ios-bluetooth.svg';
import iosBoat from './ios-boat.svg';
import iosBody from './ios-body.svg';
import iosBonfire from './ios-bonfire.svg';
import iosBook from './ios-book.svg';
import iosBookmark from './ios-bookmark.svg';
import iosBookmarks from './ios-bookmarks.svg';
import iosBowtie from './ios-bowtie.svg';
import iosBriefcase from './ios-briefcase.svg';
import iosBrowsers from './ios-browsers.svg';
import iosBrush from './ios-brush.svg';
import iosBug from './ios-bug.svg';
import iosBuild from './ios-build.svg';
import iosBulb from './ios-bulb.svg';
import iosBus from './ios-bus.svg';
import iosBusiness from './ios-business.svg';
import iosCafe from './ios-cafe.svg';
import iosCalculator from './ios-calculator.svg';
import iosCalendar from './ios-calendar.svg';
import iosCall from './ios-call.svg';
import iosCamera from './ios-camera.svg';
import iosCar from './ios-car.svg';
import iosCard from './ios-card.svg';
import iosCart from './ios-cart.svg';
import iosCash from './ios-cash.svg';
import iosCellular from './ios-cellular.svg';
import iosChatboxes from './ios-chatboxes.svg';
import iosChatbubbles from './ios-chatbubbles.svg';
import iosCheckboxOutline from './ios-checkbox-outline.svg';
import iosCheckbox from './ios-checkbox.svg';
import iosCheckmarkCircleOutline from './ios-checkmark-circle-outline.svg';
import iosCheckmarkCircle from './ios-checkmark-circle.svg';
import iosCheckmark from './ios-checkmark.svg';
import iosClipboard from './ios-clipboard.svg';
import iosClock from './ios-clock.svg';
import iosCloseCircleOutline from './ios-close-circle-outline.svg';
import iosCloseCircle from './ios-close-circle.svg';
import iosClose from './ios-close.svg';
import iosCloudCircle from './ios-cloud-circle.svg';
import iosCloudDone from './ios-cloud-done.svg';
import iosCloudDownload from './ios-cloud-download.svg';
import iosCloudOutline from './ios-cloud-outline.svg';
import iosCloudUpload from './ios-cloud-upload.svg';
import iosCloud from './ios-cloud.svg';
import iosCloudyNight from './ios-cloudy-night.svg';
import iosCloudy from './ios-cloudy.svg';
import iosCodeDownload from './ios-code-download.svg';
import iosCodeWorking from './ios-code-working.svg';
import iosCode from './ios-code.svg';
import iosCog from './ios-cog.svg';
import iosColorFill from './ios-color-fill.svg';
import iosColorFilter from './ios-color-filter.svg';
import iosColorPalette from './ios-color-palette.svg';
import iosColorWand from './ios-color-wand.svg';
import iosCompass from './ios-compass.svg';
import iosConstruct from './ios-construct.svg';
import iosContact from './ios-contact.svg';
import iosContacts from './ios-contacts.svg';
import iosContract from './ios-contract.svg';
import iosContrast from './ios-contrast.svg';
import iosCopy from './ios-copy.svg';
import iosCreate from './ios-create.svg';
import iosCrop from './ios-crop.svg';
import iosCube from './ios-cube.svg';
import iosCut from './ios-cut.svg';
import iosDesktop from './ios-desktop.svg';
import iosDisc from './ios-disc.svg';
import iosDocument from './ios-document.svg';
import iosDoneAll from './ios-done-all.svg';
import iosDownload from './ios-download.svg';
import iosEasel from './ios-easel.svg';
import iosEgg from './ios-egg.svg';
import iosExit from './ios-exit.svg';
import iosExpand from './ios-expand.svg';
import iosEyeOff from './ios-eye-off.svg';
import iosEye from './ios-eye.svg';
import iosFastforward from './ios-fastforward.svg';
import iosFemale from './ios-female.svg';
import iosFiling from './ios-filing.svg';
import iosFilm from './ios-film.svg';
import iosFingerPrint from './ios-finger-print.svg';
import iosFitness from './ios-fitness.svg';
import iosFlag from './ios-flag.svg';
import iosFlame from './ios-flame.svg';
import iosFlashOff from './ios-flash-off.svg';
import iosFlash from './ios-flash.svg';
import iosFlashlight from './ios-flashlight.svg';
import iosFlask from './ios-flask.svg';
import iosFlower from './ios-flower.svg';
import iosFolderOpen from './ios-folder-open.svg';
import iosFolder from './ios-folder.svg';
import iosFootball from './ios-football.svg';
import iosFunnel from './ios-funnel.svg';
import iosGift from './ios-gift.svg';
import iosGitBranch from './ios-git-branch.svg';
import iosGitCommit from './ios-git-commit.svg';
import iosGitCompare from './ios-git-compare.svg';
import iosGitMerge from './ios-git-merge.svg';
import iosGitNetwork from './ios-git-network.svg';
import iosGitPullRequest from './ios-git-pull-request.svg';
import iosGlasses from './ios-glasses.svg';
import iosGlobe from './ios-globe.svg';
import iosGrid from './ios-grid.svg';
import iosHammer from './ios-hammer.svg';
import iosHand from './ios-hand.svg';
import iosHappy from './ios-happy.svg';
import iosHeadset from './ios-headset.svg';
import iosHeartDislike from './ios-heart-dislike.svg';
import iosHeartEmpty from './ios-heart-empty.svg';
import iosHeartHalf from './ios-heart-half.svg';
import iosHeart from './ios-heart.svg';
import iosHelpBuoy from './ios-help-buoy.svg';
import iosHelpCircleOutline from './ios-help-circle-outline.svg';
import iosHelpCircle from './ios-help-circle.svg';
import iosHelp from './ios-help.svg';
import iosHome from './ios-home.svg';
import iosHourglass from './ios-hourglass.svg';
import iosIceCream from './ios-ice-cream.svg';
import iosImage from './ios-image.svg';
import iosImages from './ios-images.svg';
import iosInfinite from './ios-infinite.svg';
import iosInformationCircleOutline from './ios-information-circle-outline.svg';
import iosInformationCircle from './ios-information-circle.svg';
import iosInformation from './ios-information.svg';
import iosJet from './ios-jet.svg';
import iosJournal from './ios-journal.svg';
import iosKey from './ios-key.svg';
import iosKeypad from './ios-keypad.svg';
import iosLaptop from './ios-laptop.svg';
import iosLeaf from './ios-leaf.svg';
import iosLink from './ios-link.svg';
import iosListBox from './ios-list-box.svg';
import iosList from './ios-list.svg';
import iosLocate from './ios-locate.svg';
import iosLock from './ios-lock.svg';
import iosLogIn from './ios-log-in.svg';
import iosLogOut from './ios-log-out.svg';
import iosMagnet from './ios-magnet.svg';
import iosMailOpen from './ios-mail-open.svg';
import iosMailUnread from './ios-mail-unread.svg';
import iosMail from './ios-mail.svg';
import iosMale from './ios-male.svg';
import iosMan from './ios-man.svg';
import iosMap from './ios-map.svg';
import iosMedal from './ios-medal.svg';
import iosMedical from './ios-medical.svg';
import iosMedkit from './ios-medkit.svg';
import iosMegaphone from './ios-megaphone.svg';
import iosMenu from './ios-menu.svg';
import iosMicOff from './ios-mic-off.svg';
import iosMic from './ios-mic.svg';
import iosMicrophone from './ios-microphone.svg';
import iosMoon from './ios-moon.svg';
import iosMore from './ios-more.svg';
import iosMove from './ios-move.svg';
import iosMusicalNote from './ios-musical-note.svg';
import iosMusicalNotes from './ios-musical-notes.svg';
import iosNavigate from './ios-navigate.svg';
import iosNotificationsOff from './ios-notifications-off.svg';
import iosNotificationsOutline from './ios-notifications-outline.svg';
import iosNotifications from './ios-notifications.svg';
import iosNuclear from './ios-nuclear.svg';
import iosNutrition from './ios-nutrition.svg';
import iosOpen from './ios-open.svg';
import iosOptions from './ios-options.svg';
import iosOutlet from './ios-outlet.svg';
import iosPaperPlane from './ios-paper-plane.svg';
import iosPaper from './ios-paper.svg';
import iosPartlySunny from './ios-partly-sunny.svg';
import iosPause from './ios-pause.svg';
import iosPaw from './ios-paw.svg';
import iosPeople from './ios-people.svg';
import iosPersonAdd from './ios-person-add.svg';
import iosPerson from './ios-person.svg';
import iosPhoneLandscape from './ios-phone-landscape.svg';
import iosPhonePortrait from './ios-phone-portrait.svg';
import iosPhotos from './ios-photos.svg';
import iosPie from './ios-pie.svg';
import iosPin from './ios-pin.svg';
import iosPint from './ios-pint.svg';
import iosPizza from './ios-pizza.svg';
import iosPlanet from './ios-planet.svg';
import iosPlayCircle from './ios-play-circle.svg';
import iosPlay from './ios-play.svg';
import iosPodium from './ios-podium.svg';
import iosPower from './ios-power.svg';
import iosPricetag from './ios-pricetag.svg';
import iosPricetags from './ios-pricetags.svg';
import iosPrint from './ios-print.svg';
import iosPulse from './ios-pulse.svg';
import iosQrScanner from './ios-qr-scanner.svg';
import iosQuote from './ios-quote.svg';
import iosRadioButtonOff from './ios-radio-button-off.svg';
import iosRadioButtonOn from './ios-radio-button-on.svg';
import iosRadio from './ios-radio.svg';
import iosRainy from './ios-rainy.svg';
import iosRecording from './ios-recording.svg';
import iosRedo from './ios-redo.svg';
import iosRefreshCircle from './ios-refresh-circle.svg';
import iosRefresh from './ios-refresh.svg';
import iosRemoveCircleOutline from './ios-remove-circle-outline.svg';
import iosRemoveCircle from './ios-remove-circle.svg';
import iosRemove from './ios-remove.svg';
import iosReorder from './ios-reorder.svg';
import iosRepeat from './ios-repeat.svg';
import iosResize from './ios-resize.svg';
import iosRestaurant from './ios-restaurant.svg';
import iosReturnLeft from './ios-return-left.svg';
import iosReturnRight from './ios-return-right.svg';
import iosReverseCamera from './ios-reverse-camera.svg';
import iosRewind from './ios-rewind.svg';
import iosRibbon from './ios-ribbon.svg';
import iosRocket from './ios-rocket.svg';
import iosRose from './ios-rose.svg';
import iosSad from './ios-sad.svg';
import iosSave from './ios-save.svg';
import iosSchool from './ios-school.svg';
import iosSearch from './ios-search.svg';
import iosSend from './ios-send.svg';
import iosSettings from './ios-settings.svg';
import iosShareAlt from './ios-share-alt.svg';
import iosShare from './ios-share.svg';
import iosShirt from './ios-shirt.svg';
import iosShuffle from './ios-shuffle.svg';
import iosSkipBackward from './ios-skip-backward.svg';
import iosSkipForward from './ios-skip-forward.svg';
import iosSnow from './ios-snow.svg';
import iosSpeedometer from './ios-speedometer.svg';
import iosSquareOutline from './ios-square-outline.svg';
import iosSquare from './ios-square.svg';
import iosStarHalf from './ios-star-half.svg';
import iosStarOutline from './ios-star-outline.svg';
import iosStar from './ios-star.svg';
import iosStats from './ios-stats.svg';
import iosStopwatch from './ios-stopwatch.svg';
import iosSubway from './ios-subway.svg';
import iosSunny from './ios-sunny.svg';
import iosSwap from './ios-swap.svg';
import iosSwitch from './ios-switch.svg';
import iosSync from './ios-sync.svg';
import iosTabletLandscape from './ios-tablet-landscape.svg';
import iosTabletPortrait from './ios-tablet-portrait.svg';
import iosTennisball from './ios-tennisball.svg';
import iosText from './ios-text.svg';
import iosThermometer from './ios-thermometer.svg';
import iosThumbsDown from './ios-thumbs-down.svg';
import iosThumbsUp from './ios-thumbs-up.svg';
import iosThunderstorm from './ios-thunderstorm.svg';
import iosTime from './ios-time.svg';
import iosTimer from './ios-timer.svg';
import iosToday from './ios-today.svg';
import iosTrain from './ios-train.svg';
import iosTransgender from './ios-transgender.svg';
import iosTrash from './ios-trash.svg';
import iosTrendingDown from './ios-trending-down.svg';
import iosTrendingUp from './ios-trending-up.svg';
import iosTrophy from './ios-trophy.svg';
import iosTv from './ios-tv.svg';
import iosUmbrella from './ios-umbrella.svg';
import iosUndo from './ios-undo.svg';
import iosUnlock from './ios-unlock.svg';
import iosVideocam from './ios-videocam.svg';
import iosVolumeHigh from './ios-volume-high.svg';
import iosVolumeLow from './ios-volume-low.svg';
import iosVolumeMute from './ios-volume-mute.svg';
import iosVolumeOff from './ios-volume-off.svg';
import iosWalk from './ios-walk.svg';
import iosWallet from './ios-wallet.svg';
import iosWarning from './ios-warning.svg';
import iosWatch from './ios-watch.svg';
import iosWater from './ios-water.svg';
import iosWifi from './ios-wifi.svg';
import iosWine from './ios-wine.svg';
import iosWoman from './ios-woman.svg';
import logoAndroid from './logo-android.svg';
import logoAngular from './logo-angular.svg';
import logoApple from './logo-apple.svg';
import logoBitbucket from './logo-bitbucket.svg';
import logoBitcoin from './logo-bitcoin.svg';
import logoBuffer from './logo-buffer.svg';
import logoChrome from './logo-chrome.svg';
import logoClosedCaptioning from './logo-closed-captioning.svg';
import logoCodepen from './logo-codepen.svg';
import logoCss3 from './logo-css3.svg';
import logoDesignernews from './logo-designernews.svg';
import logoDribbble from './logo-dribbble.svg';
import logoDropbox from './logo-dropbox.svg';
import logoEuro from './logo-euro.svg';
import logoFacebook from './logo-facebook.svg';
import logoFlickr from './logo-flickr.svg';
import logoFoursquare from './logo-foursquare.svg';
import logoFreebsdDevil from './logo-freebsd-devil.svg';
import logoGameControllerA from './logo-game-controller-a.svg';
import logoGameControllerB from './logo-game-controller-b.svg';
import logoGithub from './logo-github.svg';
import logoGoogle from './logo-google.svg';
import logoGoogleplus from './logo-googleplus.svg';
import logoHackernews from './logo-hackernews.svg';
import logoHtml5 from './logo-html5.svg';
import logoInstagram from './logo-instagram.svg';
import logoIonic from './logo-ionic.svg';
import logoIonitron from './logo-ionitron.svg';
import logoJavascript from './logo-javascript.svg';
import logoLinkedin from './logo-linkedin.svg';
import logoMarkdown from './logo-markdown.svg';
import logoModelS from './logo-model-s.svg';
import logoNoSmoking from './logo-no-smoking.svg';
import logoNodejs from './logo-nodejs.svg';
import logoNpm from './logo-npm.svg';
import logoOctocat from './logo-octocat.svg';
import logoPinterest from './logo-pinterest.svg';
import logoPlaystation from './logo-playstation.svg';
import logoPolymer from './logo-polymer.svg';
import logoPython from './logo-python.svg';
import logoReddit from './logo-reddit.svg';
import logoRss from './logo-rss.svg';
import logoSass from './logo-sass.svg';
import logoSkype from './logo-skype.svg';
import logoSlack from './logo-slack.svg';
import logoSnapchat from './logo-snapchat.svg';
import logoSteam from './logo-steam.svg';
import logoTumblr from './logo-tumblr.svg';
import logoTux from './logo-tux.svg';
import logoTwitch from './logo-twitch.svg';
import logoTwitter from './logo-twitter.svg';
import logoUsd from './logo-usd.svg';
import logoVimeo from './logo-vimeo.svg';
import logoVk from './logo-vk.svg';
import logoWhatsapp from './logo-whatsapp.svg';
import logoWindows from './logo-windows.svg';
import logoWordpress from './logo-wordpress.svg';
import logoXbox from './logo-xbox.svg';
import logoXing from './logo-xing.svg';
import logoYahoo from './logo-yahoo.svg';
import logoYen from './logo-yen.svg';
import logoYoutube from './logo-youtube.svg';
import mdAddCircleOutline from './md-add-circle-outline.svg';
import mdAddCircle from './md-add-circle.svg';
import mdAdd from './md-add.svg';
import mdAirplane from './md-airplane.svg';
import mdAlarm from './md-alarm.svg';
import mdAlbums from './md-albums.svg';
import mdAlert from './md-alert.svg';
import mdAmericanFootball from './md-american-football.svg';
import mdAnalytics from './md-analytics.svg';
import mdAperture from './md-aperture.svg';
import mdApps from './md-apps.svg';
import mdAppstore from './md-appstore.svg';
import mdArchive from './md-archive.svg';
import mdArrowBack from './md-arrow-back.svg';
import mdArrowDown from './md-arrow-down.svg';
import mdArrowDropdownCircle from './md-arrow-dropdown-circle.svg';
import mdArrowDropdown from './md-arrow-dropdown.svg';
import mdArrowDropleftCircle from './md-arrow-dropleft-circle.svg';
import mdArrowDropleft from './md-arrow-dropleft.svg';
import mdArrowDroprightCircle from './md-arrow-dropright-circle.svg';
import mdArrowDropright from './md-arrow-dropright.svg';
import mdArrowDropupCircle from './md-arrow-dropup-circle.svg';
import mdArrowDropup from './md-arrow-dropup.svg';
import mdArrowForward from './md-arrow-forward.svg';
import mdArrowRoundBack from './md-arrow-round-back.svg';
import mdArrowRoundDown from './md-arrow-round-down.svg';
import mdArrowRoundForward from './md-arrow-round-forward.svg';
import mdArrowRoundUp from './md-arrow-round-up.svg';
import mdArrowUp from './md-arrow-up.svg';
import mdAt from './md-at.svg';
import mdAttach from './md-attach.svg';
import mdBackspace from './md-backspace.svg';
import mdBarcode from './md-barcode.svg';
import mdBaseball from './md-baseball.svg';
import mdBasket from './md-basket.svg';
import mdBasketball from './md-basketball.svg';
import mdBatteryCharging from './md-battery-charging.svg';
import mdBatteryDead from './md-battery-dead.svg';
import mdBatteryFull from './md-battery-full.svg';
import mdBeaker from './md-beaker.svg';
import mdBed from './md-bed.svg';
import mdBeer from './md-beer.svg';
import mdBicycle from './md-bicycle.svg';
import mdBluetooth from './md-bluetooth.svg';
import mdBoat from './md-boat.svg';
import mdBody from './md-body.svg';
import mdBonfire from './md-bonfire.svg';
import mdBook from './md-book.svg';
import mdBookmark from './md-bookmark.svg';
import mdBookmarks from './md-bookmarks.svg';
import mdBowtie from './md-bowtie.svg';
import mdBriefcase from './md-briefcase.svg';
import mdBrowsers from './md-browsers.svg';
import mdBrush from './md-brush.svg';
import mdBug from './md-bug.svg';
import mdBuild from './md-build.svg';
import mdBulb from './md-bulb.svg';
import mdBus from './md-bus.svg';
import mdBusiness from './md-business.svg';
import mdCafe from './md-cafe.svg';
import mdCalculator from './md-calculator.svg';
import mdCalendar from './md-calendar.svg';
import mdCall from './md-call.svg';
import mdCamera from './md-camera.svg';
import mdCar from './md-car.svg';
import mdCard from './md-card.svg';
import mdCart from './md-cart.svg';
import mdCash from './md-cash.svg';
import mdCellular from './md-cellular.svg';
import mdChatboxes from './md-chatboxes.svg';
import mdChatbubbles from './md-chatbubbles.svg';
import mdCheckboxOutline from './md-checkbox-outline.svg';
import mdCheckbox from './md-checkbox.svg';
import mdCheckmarkCircleOutline from './md-checkmark-circle-outline.svg';
import mdCheckmarkCircle from './md-checkmark-circle.svg';
import mdCheckmark from './md-checkmark.svg';
import mdClipboard from './md-clipboard.svg';
import mdClock from './md-clock.svg';
import mdCloseCircleOutline from './md-close-circle-outline.svg';
import mdCloseCircle from './md-close-circle.svg';
import mdClose from './md-close.svg';
import mdCloudCircle from './md-cloud-circle.svg';
import mdCloudDone from './md-cloud-done.svg';
import mdCloudDownload from './md-cloud-download.svg';
import mdCloudOutline from './md-cloud-outline.svg';
import mdCloudUpload from './md-cloud-upload.svg';
import mdCloud from './md-cloud.svg';
import mdCloudyNight from './md-cloudy-night.svg';
import mdCloudy from './md-cloudy.svg';
import mdCodeDownload from './md-code-download.svg';
import mdCodeWorking from './md-code-working.svg';
import mdCode from './md-code.svg';
import mdCog from './md-cog.svg';
import mdColorFill from './md-color-fill.svg';
import mdColorFilter from './md-color-filter.svg';
import mdColorPalette from './md-color-palette.svg';
import mdColorWand from './md-color-wand.svg';
import mdCompass from './md-compass.svg';
import mdConstruct from './md-construct.svg';
import mdContact from './md-contact.svg';
import mdContacts from './md-contacts.svg';
import mdContract from './md-contract.svg';
import mdContrast from './md-contrast.svg';
import mdCopy from './md-copy.svg';
import mdCreate from './md-create.svg';
import mdCrop from './md-crop.svg';
import mdCube from './md-cube.svg';
import mdCut from './md-cut.svg';
import mdDesktop from './md-desktop.svg';
import mdDisc from './md-disc.svg';
import mdDocument from './md-document.svg';
import mdDoneAll from './md-done-all.svg';
import mdDownload from './md-download.svg';
import mdEasel from './md-easel.svg';
import mdEgg from './md-egg.svg';
import mdExit from './md-exit.svg';
import mdExpand from './md-expand.svg';
import mdEyeOff from './md-eye-off.svg';
import mdEye from './md-eye.svg';
import mdFastforward from './md-fastforward.svg';
import mdFemale from './md-female.svg';
import mdFiling from './md-filing.svg';
import mdFilm from './md-film.svg';
import mdFingerPrint from './md-finger-print.svg';
import mdFitness from './md-fitness.svg';
import mdFlag from './md-flag.svg';
import mdFlame from './md-flame.svg';
import mdFlashOff from './md-flash-off.svg';
import mdFlash from './md-flash.svg';
import mdFlashlight from './md-flashlight.svg';
import mdFlask from './md-flask.svg';
import mdFlower from './md-flower.svg';
import mdFolderOpen from './md-folder-open.svg';
import mdFolder from './md-folder.svg';
import mdFootball from './md-football.svg';
import mdFunnel from './md-funnel.svg';
import mdGift from './md-gift.svg';
import mdGitBranch from './md-git-branch.svg';
import mdGitCommit from './md-git-commit.svg';
import mdGitCompare from './md-git-compare.svg';
import mdGitMerge from './md-git-merge.svg';
import mdGitNetwork from './md-git-network.svg';
import mdGitPullRequest from './md-git-pull-request.svg';
import mdGlasses from './md-glasses.svg';
import mdGlobe from './md-globe.svg';
import mdGrid from './md-grid.svg';
import mdHammer from './md-hammer.svg';
import mdHand from './md-hand.svg';
import mdHappy from './md-happy.svg';
import mdHeadset from './md-headset.svg';
import mdHeartDislike from './md-heart-dislike.svg';
import mdHeartEmpty from './md-heart-empty.svg';
import mdHeartHalf from './md-heart-half.svg';
import mdHeart from './md-heart.svg';
import mdHelpBuoy from './md-help-buoy.svg';
import mdHelpCircleOutline from './md-help-circle-outline.svg';
import mdHelpCircle from './md-help-circle.svg';
import mdHelp from './md-help.svg';
import mdHome from './md-home.svg';
import mdHourglass from './md-hourglass.svg';
import mdIceCream from './md-ice-cream.svg';
import mdImage from './md-image.svg';
import mdImages from './md-images.svg';
import mdInfinite from './md-infinite.svg';
import mdInformationCircleOutline from './md-information-circle-outline.svg';
import mdInformationCircle from './md-information-circle.svg';
import mdInformation from './md-information.svg';
import mdJet from './md-jet.svg';
import mdJournal from './md-journal.svg';
import mdKey from './md-key.svg';
import mdKeypad from './md-keypad.svg';
import mdLaptop from './md-laptop.svg';
import mdLeaf from './md-leaf.svg';
import mdLink from './md-link.svg';
import mdListBox from './md-list-box.svg';
import mdList from './md-list.svg';
import mdLocate from './md-locate.svg';
import mdLock from './md-lock.svg';
import mdLogIn from './md-log-in.svg';
import mdLogOut from './md-log-out.svg';
import mdMagnet from './md-magnet.svg';
import mdMailOpen from './md-mail-open.svg';
import mdMailUnread from './md-mail-unread.svg';
import mdMail from './md-mail.svg';
import mdMale from './md-male.svg';
import mdMan from './md-man.svg';
import mdMap from './md-map.svg';
import mdMedal from './md-medal.svg';
import mdMedical from './md-medical.svg';
import mdMedkit from './md-medkit.svg';
import mdMegaphone from './md-megaphone.svg';
import mdMenu from './md-menu.svg';
import mdMicOff from './md-mic-off.svg';
import mdMic from './md-mic.svg';
import mdMicrophone from './md-microphone.svg';
import mdMoon from './md-moon.svg';
import mdMore from './md-more.svg';
import mdMove from './md-move.svg';
import mdMusicalNote from './md-musical-note.svg';
import mdMusicalNotes from './md-musical-notes.svg';
import mdNavigate from './md-navigate.svg';
import mdNotificationsOff from './md-notifications-off.svg';
import mdNotificationsOutline from './md-notifications-outline.svg';
import mdNotifications from './md-notifications.svg';
import mdNuclear from './md-nuclear.svg';
import mdNutrition from './md-nutrition.svg';
import mdOpen from './md-open.svg';
import mdOptions from './md-options.svg';
import mdOutlet from './md-outlet.svg';
import mdPaperPlane from './md-paper-plane.svg';
import mdPaper from './md-paper.svg';
import mdPartlySunny from './md-partly-sunny.svg';
import mdPause from './md-pause.svg';
import mdPaw from './md-paw.svg';
import mdPeople from './md-people.svg';
import mdPersonAdd from './md-person-add.svg';
import mdPerson from './md-person.svg';
import mdPhoneLandscape from './md-phone-landscape.svg';
import mdPhonePortrait from './md-phone-portrait.svg';
import mdPhotos from './md-photos.svg';
import mdPie from './md-pie.svg';
import mdPin from './md-pin.svg';
import mdPint from './md-pint.svg';
import mdPizza from './md-pizza.svg';
import mdPlanet from './md-planet.svg';
import mdPlayCircle from './md-play-circle.svg';
import mdPlay from './md-play.svg';
import mdPodium from './md-podium.svg';
import mdPower from './md-power.svg';
import mdPricetag from './md-pricetag.svg';
import mdPricetags from './md-pricetags.svg';
import mdPrint from './md-print.svg';
import mdPulse from './md-pulse.svg';
import mdQrScanner from './md-qr-scanner.svg';
import mdQuote from './md-quote.svg';
import mdRadioButtonOff from './md-radio-button-off.svg';
import mdRadioButtonOn from './md-radio-button-on.svg';
import mdRadio from './md-radio.svg';
import mdRainy from './md-rainy.svg';
import mdRecording from './md-recording.svg';
import mdRedo from './md-redo.svg';
import mdRefreshCircle from './md-refresh-circle.svg';
import mdRefresh from './md-refresh.svg';
import mdRemoveCircleOutline from './md-remove-circle-outline.svg';
import mdRemoveCircle from './md-remove-circle.svg';
import mdRemove from './md-remove.svg';
import mdReorder from './md-reorder.svg';
import mdRepeat from './md-repeat.svg';
import mdResize from './md-resize.svg';
import mdRestaurant from './md-restaurant.svg';
import mdReturnLeft from './md-return-left.svg';
import mdReturnRight from './md-return-right.svg';
import mdReverseCamera from './md-reverse-camera.svg';
import mdRewind from './md-rewind.svg';
import mdRibbon from './md-ribbon.svg';
import mdRocket from './md-rocket.svg';
import mdRose from './md-rose.svg';
import mdSad from './md-sad.svg';
import mdSave from './md-save.svg';
import mdSchool from './md-school.svg';
import mdSearch from './md-search.svg';
import mdSend from './md-send.svg';
import mdSettings from './md-settings.svg';
import mdShareAlt from './md-share-alt.svg';
import mdShare from './md-share.svg';
import mdShirt from './md-shirt.svg';
import mdShuffle from './md-shuffle.svg';
import mdSkipBackward from './md-skip-backward.svg';
import mdSkipForward from './md-skip-forward.svg';
import mdSnow from './md-snow.svg';
import mdSpeedometer from './md-speedometer.svg';
import mdSquareOutline from './md-square-outline.svg';
import mdSquare from './md-square.svg';
import mdStarHalf from './md-star-half.svg';
import mdStarOutline from './md-star-outline.svg';
import mdStar from './md-star.svg';
import mdStats from './md-stats.svg';
import mdStopwatch from './md-stopwatch.svg';
import mdSubway from './md-subway.svg';
import mdSunny from './md-sunny.svg';
import mdSwap from './md-swap.svg';
import mdSwitch from './md-switch.svg';
import mdSync from './md-sync.svg';
import mdTabletLandscape from './md-tablet-landscape.svg';
import mdTabletPortrait from './md-tablet-portrait.svg';
import mdTennisball from './md-tennisball.svg';
import mdText from './md-text.svg';
import mdThermometer from './md-thermometer.svg';
import mdThumbsDown from './md-thumbs-down.svg';
import mdThumbsUp from './md-thumbs-up.svg';
import mdThunderstorm from './md-thunderstorm.svg';
import mdTime from './md-time.svg';
import mdTimer from './md-timer.svg';
import mdToday from './md-today.svg';
import mdTrain from './md-train.svg';
import mdTransgender from './md-transgender.svg';
import mdTrash from './md-trash.svg';
import mdTrendingDown from './md-trending-down.svg';
import mdTrendingUp from './md-trending-up.svg';
import mdTrophy from './md-trophy.svg';
import mdTv from './md-tv.svg';
import mdUmbrella from './md-umbrella.svg';
import mdUndo from './md-undo.svg';
import mdUnlock from './md-unlock.svg';
import mdVideocam from './md-videocam.svg';
import mdVolumeHigh from './md-volume-high.svg';
import mdVolumeLow from './md-volume-low.svg';
import mdVolumeMute from './md-volume-mute.svg';
import mdVolumeOff from './md-volume-off.svg';
import mdWalk from './md-walk.svg';
import mdWallet from './md-wallet.svg';
import mdWarning from './md-warning.svg';
import mdWatch from './md-watch.svg';
import mdWater from './md-water.svg';
import mdWifi from './md-wifi.svg';
import mdWine from './md-wine.svg';
import mdWoman from './md-woman.svg';

export var ICON_PATHS = {
  'ios-add-circle-outline': iosAddCircleOutline,
  'ios-add-circle': iosAddCircle,
  'ios-add': iosAdd,
  'ios-airplane': iosAirplane,
  'ios-alarm': iosAlarm,
  'ios-albums': iosAlbums,
  'ios-alert': iosAlert,
  'ios-american-football': iosAmericanFootball,
  'ios-analytics': iosAnalytics,
  'ios-aperture': iosAperture,
  'ios-apps': iosApps,
  'ios-appstore': iosAppstore,
  'ios-archive': iosArchive,
  'ios-arrow-back': iosArrowBack,
  'ios-arrow-down': iosArrowDown,
  'ios-arrow-dropdown-circle': iosArrowDropdownCircle,
  'ios-arrow-dropdown': iosArrowDropdown,
  'ios-arrow-dropleft-circle': iosArrowDropleftCircle,
  'ios-arrow-dropleft': iosArrowDropleft,
  'ios-arrow-dropright-circle': iosArrowDroprightCircle,
  'ios-arrow-dropright': iosArrowDropright,
  'ios-arrow-dropup-circle': iosArrowDropupCircle,
  'ios-arrow-dropup': iosArrowDropup,
  'ios-arrow-forward': iosArrowForward,
  'ios-arrow-round-back': iosArrowRoundBack,
  'ios-arrow-round-down': iosArrowRoundDown,
  'ios-arrow-round-forward': iosArrowRoundForward,
  'ios-arrow-round-up': iosArrowRoundUp,
  'ios-arrow-up': iosArrowUp,
  'ios-at': iosAt,
  'ios-attach': iosAttach,
  'ios-backspace': iosBackspace,
  'ios-barcode': iosBarcode,
  'ios-baseball': iosBaseball,
  'ios-basket': iosBasket,
  'ios-basketball': iosBasketball,
  'ios-battery-charging': iosBatteryCharging,
  'ios-battery-dead': iosBatteryDead,
  'ios-battery-full': iosBatteryFull,
  'ios-beaker': iosBeaker,
  'ios-bed': iosBed,
  'ios-beer': iosBeer,
  'ios-bicycle': iosBicycle,
  'ios-bluetooth': iosBluetooth,
  'ios-boat': iosBoat,
  'ios-body': iosBody,
  'ios-bonfire': iosBonfire,
  'ios-book': iosBook,
  'ios-bookmark': iosBookmark,
  'ios-bookmarks': iosBookmarks,
  'ios-bowtie': iosBowtie,
  'ios-briefcase': iosBriefcase,
  'ios-browsers': iosBrowsers,
  'ios-brush': iosBrush,
  'ios-bug': iosBug,
  'ios-build': iosBuild,
  'ios-bulb': iosBulb,
  'ios-bus': iosBus,
  'ios-business': iosBusiness,
  'ios-cafe': iosCafe,
  'ios-calculator': iosCalculator,
  'ios-calendar': iosCalendar,
  'ios-call': iosCall,
  'ios-camera': iosCamera,
  'ios-car': iosCar,
  'ios-card': iosCard,
  'ios-cart': iosCart,
  'ios-cash': iosCash,
  'ios-cellular': iosCellular,
  'ios-chatboxes': iosChatboxes,
  'ios-chatbubbles': iosChatbubbles,
  'ios-checkbox-outline': iosCheckboxOutline,
  'ios-checkbox': iosCheckbox,
  'ios-checkmark-circle-outline': iosCheckmarkCircleOutline,
  'ios-checkmark-circle': iosCheckmarkCircle,
  'ios-checkmark': iosCheckmark,
  'ios-clipboard': iosClipboard,
  'ios-clock': iosClock,
  'ios-close-circle-outline': iosCloseCircleOutline,
  'ios-close-circle': iosCloseCircle,
  'ios-close': iosClose,
  'ios-cloud-circle': iosCloudCircle,
  'ios-cloud-done': iosCloudDone,
  'ios-cloud-download': iosCloudDownload,
  'ios-cloud-outline': iosCloudOutline,
  'ios-cloud-upload': iosCloudUpload,
  'ios-cloud': iosCloud,
  'ios-cloudy-night': iosCloudyNight,
  'ios-cloudy': iosCloudy,
  'ios-code-download': iosCodeDownload,
  'ios-code-working': iosCodeWorking,
  'ios-code': iosCode,
  'ios-cog': iosCog,
  'ios-color-fill': iosColorFill,
  'ios-color-filter': iosColorFilter,
  'ios-color-palette': iosColorPalette,
  'ios-color-wand': iosColorWand,
  'ios-compass': iosCompass,
  'ios-construct': iosConstruct,
  'ios-contact': iosContact,
  'ios-contacts': iosContacts,
  'ios-contract': iosContract,
  'ios-contrast': iosContrast,
  'ios-copy': iosCopy,
  'ios-create': iosCreate,
  'ios-crop': iosCrop,
  'ios-cube': iosCube,
  'ios-cut': iosCut,
  'ios-desktop': iosDesktop,
  'ios-disc': iosDisc,
  'ios-document': iosDocument,
  'ios-done-all': iosDoneAll,
  'ios-download': iosDownload,
  'ios-easel': iosEasel,
  'ios-egg': iosEgg,
  'ios-exit': iosExit,
  'ios-expand': iosExpand,
  'ios-eye-off': iosEyeOff,
  'ios-eye': iosEye,
  'ios-fastforward': iosFastforward,
  'ios-female': iosFemale,
  'ios-filing': iosFiling,
  'ios-film': iosFilm,
  'ios-finger-print': iosFingerPrint,
  'ios-fitness': iosFitness,
  'ios-flag': iosFlag,
  'ios-flame': iosFlame,
  'ios-flash-off': iosFlashOff,
  'ios-flash': iosFlash,
  'ios-flashlight': iosFlashlight,
  'ios-flask': iosFlask,
  'ios-flower': iosFlower,
  'ios-folder-open': iosFolderOpen,
  'ios-folder': iosFolder,
  'ios-football': iosFootball,
  'ios-funnel': iosFunnel,
  'ios-gift': iosGift,
  'ios-git-branch': iosGitBranch,
  'ios-git-commit': iosGitCommit,
  'ios-git-compare': iosGitCompare,
  'ios-git-merge': iosGitMerge,
  'ios-git-network': iosGitNetwork,
  'ios-git-pull-request': iosGitPullRequest,
  'ios-glasses': iosGlasses,
  'ios-globe': iosGlobe,
  'ios-grid': iosGrid,
  'ios-hammer': iosHammer,
  'ios-hand': iosHand,
  'ios-happy': iosHappy,
  'ios-headset': iosHeadset,
  'ios-heart-dislike': iosHeartDislike,
  'ios-heart-empty': iosHeartEmpty,
  'ios-heart-half': iosHeartHalf,
  'ios-heart': iosHeart,
  'ios-help-buoy': iosHelpBuoy,
  'ios-help-circle-outline': iosHelpCircleOutline,
  'ios-help-circle': iosHelpCircle,
  'ios-help': iosHelp,
  'ios-home': iosHome,
  'ios-hourglass': iosHourglass,
  'ios-ice-cream': iosIceCream,
  'ios-image': iosImage,
  'ios-images': iosImages,
  'ios-infinite': iosInfinite,
  'ios-information-circle-outline': iosInformationCircleOutline,
  'ios-information-circle': iosInformationCircle,
  'ios-information': iosInformation,
  'ios-jet': iosJet,
  'ios-journal': iosJournal,
  'ios-key': iosKey,
  'ios-keypad': iosKeypad,
  'ios-laptop': iosLaptop,
  'ios-leaf': iosLeaf,
  'ios-link': iosLink,
  'ios-list-box': iosListBox,
  'ios-list': iosList,
  'ios-locate': iosLocate,
  'ios-lock': iosLock,
  'ios-log-in': iosLogIn,
  'ios-log-out': iosLogOut,
  'ios-magnet': iosMagnet,
  'ios-mail-open': iosMailOpen,
  'ios-mail-unread': iosMailUnread,
  'ios-mail': iosMail,
  'ios-male': iosMale,
  'ios-man': iosMan,
  'ios-map': iosMap,
  'ios-medal': iosMedal,
  'ios-medical': iosMedical,
  'ios-medkit': iosMedkit,
  'ios-megaphone': iosMegaphone,
  'ios-menu': iosMenu,
  'ios-mic-off': iosMicOff,
  'ios-mic': iosMic,
  'ios-microphone': iosMicrophone,
  'ios-moon': iosMoon,
  'ios-more': iosMore,
  'ios-move': iosMove,
  'ios-musical-note': iosMusicalNote,
  'ios-musical-notes': iosMusicalNotes,
  'ios-navigate': iosNavigate,
  'ios-notifications-off': iosNotificationsOff,
  'ios-notifications-outline': iosNotificationsOutline,
  'ios-notifications': iosNotifications,
  'ios-nuclear': iosNuclear,
  'ios-nutrition': iosNutrition,
  'ios-open': iosOpen,
  'ios-options': iosOptions,
  'ios-outlet': iosOutlet,
  'ios-paper-plane': iosPaperPlane,
  'ios-paper': iosPaper,
  'ios-partly-sunny': iosPartlySunny,
  'ios-pause': iosPause,
  'ios-paw': iosPaw,
  'ios-people': iosPeople,
  'ios-person-add': iosPersonAdd,
  'ios-person': iosPerson,
  'ios-phone-landscape': iosPhoneLandscape,
  'ios-phone-portrait': iosPhonePortrait,
  'ios-photos': iosPhotos,
  'ios-pie': iosPie,
  'ios-pin': iosPin,
  'ios-pint': iosPint,
  'ios-pizza': iosPizza,
  'ios-planet': iosPlanet,
  'ios-play-circle': iosPlayCircle,
  'ios-play': iosPlay,
  'ios-podium': iosPodium,
  'ios-power': iosPower,
  'ios-pricetag': iosPricetag,
  'ios-pricetags': iosPricetags,
  'ios-print': iosPrint,
  'ios-pulse': iosPulse,
  'ios-qr-scanner': iosQrScanner,
  'ios-quote': iosQuote,
  'ios-radio-button-off': iosRadioButtonOff,
  'ios-radio-button-on': iosRadioButtonOn,
  'ios-radio': iosRadio,
  'ios-rainy': iosRainy,
  'ios-recording': iosRecording,
  'ios-redo': iosRedo,
  'ios-refresh-circle': iosRefreshCircle,
  'ios-refresh': iosRefresh,
  'ios-remove-circle-outline': iosRemoveCircleOutline,
  'ios-remove-circle': iosRemoveCircle,
  'ios-remove': iosRemove,
  'ios-reorder': iosReorder,
  'ios-repeat': iosRepeat,
  'ios-resize': iosResize,
  'ios-restaurant': iosRestaurant,
  'ios-return-left': iosReturnLeft,
  'ios-return-right': iosReturnRight,
  'ios-reverse-camera': iosReverseCamera,
  'ios-rewind': iosRewind,
  'ios-ribbon': iosRibbon,
  'ios-rocket': iosRocket,
  'ios-rose': iosRose,
  'ios-sad': iosSad,
  'ios-save': iosSave,
  'ios-school': iosSchool,
  'ios-search': iosSearch,
  'ios-send': iosSend,
  'ios-settings': iosSettings,
  'ios-share-alt': iosShareAlt,
  'ios-share': iosShare,
  'ios-shirt': iosShirt,
  'ios-shuffle': iosShuffle,
  'ios-skip-backward': iosSkipBackward,
  'ios-skip-forward': iosSkipForward,
  'ios-snow': iosSnow,
  'ios-speedometer': iosSpeedometer,
  'ios-square-outline': iosSquareOutline,
  'ios-square': iosSquare,
  'ios-star-half': iosStarHalf,
  'ios-star-outline': iosStarOutline,
  'ios-star': iosStar,
  'ios-stats': iosStats,
  'ios-stopwatch': iosStopwatch,
  'ios-subway': iosSubway,
  'ios-sunny': iosSunny,
  'ios-swap': iosSwap,
  'ios-switch': iosSwitch,
  'ios-sync': iosSync,
  'ios-tablet-landscape': iosTabletLandscape,
  'ios-tablet-portrait': iosTabletPortrait,
  'ios-tennisball': iosTennisball,
  'ios-text': iosText,
  'ios-thermometer': iosThermometer,
  'ios-thumbs-down': iosThumbsDown,
  'ios-thumbs-up': iosThumbsUp,
  'ios-thunderstorm': iosThunderstorm,
  'ios-time': iosTime,
  'ios-timer': iosTimer,
  'ios-today': iosToday,
  'ios-train': iosTrain,
  'ios-transgender': iosTransgender,
  'ios-trash': iosTrash,
  'ios-trending-down': iosTrendingDown,
  'ios-trending-up': iosTrendingUp,
  'ios-trophy': iosTrophy,
  'ios-tv': iosTv,
  'ios-umbrella': iosUmbrella,
  'ios-undo': iosUndo,
  'ios-unlock': iosUnlock,
  'ios-videocam': iosVideocam,
  'ios-volume-high': iosVolumeHigh,
  'ios-volume-low': iosVolumeLow,
  'ios-volume-mute': iosVolumeMute,
  'ios-volume-off': iosVolumeOff,
  'ios-walk': iosWalk,
  'ios-wallet': iosWallet,
  'ios-warning': iosWarning,
  'ios-watch': iosWatch,
  'ios-water': iosWater,
  'ios-wifi': iosWifi,
  'ios-wine': iosWine,
  'ios-woman': iosWoman,
  'logo-android': logoAndroid,
  'logo-angular': logoAngular,
  'logo-apple': logoApple,
  'logo-bitbucket': logoBitbucket,
  'logo-bitcoin': logoBitcoin,
  'logo-buffer': logoBuffer,
  'logo-chrome': logoChrome,
  'logo-closed-captioning': logoClosedCaptioning,
  'logo-codepen': logoCodepen,
  'logo-css3': logoCss3,
  'logo-designernews': logoDesignernews,
  'logo-dribbble': logoDribbble,
  'logo-dropbox': logoDropbox,
  'logo-euro': logoEuro,
  'logo-facebook': logoFacebook,
  'logo-flickr': logoFlickr,
  'logo-foursquare': logoFoursquare,
  'logo-freebsd-devil': logoFreebsdDevil,
  'logo-game-controller-a': logoGameControllerA,
  'logo-game-controller-b': logoGameControllerB,
  'logo-github': logoGithub,
  'logo-google': logoGoogle,
  'logo-googleplus': logoGoogleplus,
  'logo-hackernews': logoHackernews,
  'logo-html5': logoHtml5,
  'logo-instagram': logoInstagram,
  'logo-ionic': logoIonic,
  'logo-ionitron': logoIonitron,
  'logo-javascript': logoJavascript,
  'logo-linkedin': logoLinkedin,
  'logo-markdown': logoMarkdown,
  'logo-model-s': logoModelS,
  'logo-no-smoking': logoNoSmoking,
  'logo-nodejs': logoNodejs,
  'logo-npm': logoNpm,
  'logo-octocat': logoOctocat,
  'logo-pinterest': logoPinterest,
  'logo-playstation': logoPlaystation,
  'logo-polymer': logoPolymer,
  'logo-python': logoPython,
  'logo-reddit': logoReddit,
  'logo-rss': logoRss,
  'logo-sass': logoSass,
  'logo-skype': logoSkype,
  'logo-slack': logoSlack,
  'logo-snapchat': logoSnapchat,
  'logo-steam': logoSteam,
  'logo-tumblr': logoTumblr,
  'logo-tux': logoTux,
  'logo-twitch': logoTwitch,
  'logo-twitter': logoTwitter,
  'logo-usd': logoUsd,
  'logo-vimeo': logoVimeo,
  'logo-vk': logoVk,
  'logo-whatsapp': logoWhatsapp,
  'logo-windows': logoWindows,
  'logo-wordpress': logoWordpress,
  'logo-xbox': logoXbox,
  'logo-xing': logoXing,
  'logo-yahoo': logoYahoo,
  'logo-yen': logoYen,
  'logo-youtube': logoYoutube,
  'md-add-circle-outline': mdAddCircleOutline,
  'md-add-circle': mdAddCircle,
  'md-add': mdAdd,
  'md-airplane': mdAirplane,
  'md-alarm': mdAlarm,
  'md-albums': mdAlbums,
  'md-alert': mdAlert,
  'md-american-football': mdAmericanFootball,
  'md-analytics': mdAnalytics,
  'md-aperture': mdAperture,
  'md-apps': mdApps,
  'md-appstore': mdAppstore,
  'md-archive': mdArchive,
  'md-arrow-back': mdArrowBack,
  'md-arrow-down': mdArrowDown,
  'md-arrow-dropdown-circle': mdArrowDropdownCircle,
  'md-arrow-dropdown': mdArrowDropdown,
  'md-arrow-dropleft-circle': mdArrowDropleftCircle,
  'md-arrow-dropleft': mdArrowDropleft,
  'md-arrow-dropright-circle': mdArrowDroprightCircle,
  'md-arrow-dropright': mdArrowDropright,
  'md-arrow-dropup-circle': mdArrowDropupCircle,
  'md-arrow-dropup': mdArrowDropup,
  'md-arrow-forward': mdArrowForward,
  'md-arrow-round-back': mdArrowRoundBack,
  'md-arrow-round-down': mdArrowRoundDown,
  'md-arrow-round-forward': mdArrowRoundForward,
  'md-arrow-round-up': mdArrowRoundUp,
  'md-arrow-up': mdArrowUp,
  'md-at': mdAt,
  'md-attach': mdAttach,
  'md-backspace': mdBackspace,
  'md-barcode': mdBarcode,
  'md-baseball': mdBaseball,
  'md-basket': mdBasket,
  'md-basketball': mdBasketball,
  'md-battery-charging': mdBatteryCharging,
  'md-battery-dead': mdBatteryDead,
  'md-battery-full': mdBatteryFull,
  'md-beaker': mdBeaker,
  'md-bed': mdBed,
  'md-beer': mdBeer,
  'md-bicycle': mdBicycle,
  'md-bluetooth': mdBluetooth,
  'md-boat': mdBoat,
  'md-body': mdBody,
  'md-bonfire': mdBonfire,
  'md-book': mdBook,
  'md-bookmark': mdBookmark,
  'md-bookmarks': mdBookmarks,
  'md-bowtie': mdBowtie,
  'md-briefcase': mdBriefcase,
  'md-browsers': mdBrowsers,
  'md-brush': mdBrush,
  'md-bug': mdBug,
  'md-build': mdBuild,
  'md-bulb': mdBulb,
  'md-bus': mdBus,
  'md-business': mdBusiness,
  'md-cafe': mdCafe,
  'md-calculator': mdCalculator,
  'md-calendar': mdCalendar,
  'md-call': mdCall,
  'md-camera': mdCamera,
  'md-car': mdCar,
  'md-card': mdCard,
  'md-cart': mdCart,
  'md-cash': mdCash,
  'md-cellular': mdCellular,
  'md-chatboxes': mdChatboxes,
  'md-chatbubbles': mdChatbubbles,
  'md-checkbox-outline': mdCheckboxOutline,
  'md-checkbox': mdCheckbox,
  'md-checkmark-circle-outline': mdCheckmarkCircleOutline,
  'md-checkmark-circle': mdCheckmarkCircle,
  'md-checkmark': mdCheckmark,
  'md-clipboard': mdClipboard,
  'md-clock': mdClock,
  'md-close-circle-outline': mdCloseCircleOutline,
  'md-close-circle': mdCloseCircle,
  'md-close': mdClose,
  'md-cloud-circle': mdCloudCircle,
  'md-cloud-done': mdCloudDone,
  'md-cloud-download': mdCloudDownload,
  'md-cloud-outline': mdCloudOutline,
  'md-cloud-upload': mdCloudUpload,
  'md-cloud': mdCloud,
  'md-cloudy-night': mdCloudyNight,
  'md-cloudy': mdCloudy,
  'md-code-download': mdCodeDownload,
  'md-code-working': mdCodeWorking,
  'md-code': mdCode,
  'md-cog': mdCog,
  'md-color-fill': mdColorFill,
  'md-color-filter': mdColorFilter,
  'md-color-palette': mdColorPalette,
  'md-color-wand': mdColorWand,
  'md-compass': mdCompass,
  'md-construct': mdConstruct,
  'md-contact': mdContact,
  'md-contacts': mdContacts,
  'md-contract': mdContract,
  'md-contrast': mdContrast,
  'md-copy': mdCopy,
  'md-create': mdCreate,
  'md-crop': mdCrop,
  'md-cube': mdCube,
  'md-cut': mdCut,
  'md-desktop': mdDesktop,
  'md-disc': mdDisc,
  'md-document': mdDocument,
  'md-done-all': mdDoneAll,
  'md-download': mdDownload,
  'md-easel': mdEasel,
  'md-egg': mdEgg,
  'md-exit': mdExit,
  'md-expand': mdExpand,
  'md-eye-off': mdEyeOff,
  'md-eye': mdEye,
  'md-fastforward': mdFastforward,
  'md-female': mdFemale,
  'md-filing': mdFiling,
  'md-film': mdFilm,
  'md-finger-print': mdFingerPrint,
  'md-fitness': mdFitness,
  'md-flag': mdFlag,
  'md-flame': mdFlame,
  'md-flash-off': mdFlashOff,
  'md-flash': mdFlash,
  'md-flashlight': mdFlashlight,
  'md-flask': mdFlask,
  'md-flower': mdFlower,
  'md-folder-open': mdFolderOpen,
  'md-folder': mdFolder,
  'md-football': mdFootball,
  'md-funnel': mdFunnel,
  'md-gift': mdGift,
  'md-git-branch': mdGitBranch,
  'md-git-commit': mdGitCommit,
  'md-git-compare': mdGitCompare,
  'md-git-merge': mdGitMerge,
  'md-git-network': mdGitNetwork,
  'md-git-pull-request': mdGitPullRequest,
  'md-glasses': mdGlasses,
  'md-globe': mdGlobe,
  'md-grid': mdGrid,
  'md-hammer': mdHammer,
  'md-hand': mdHand,
  'md-happy': mdHappy,
  'md-headset': mdHeadset,
  'md-heart-dislike': mdHeartDislike,
  'md-heart-empty': mdHeartEmpty,
  'md-heart-half': mdHeartHalf,
  'md-heart': mdHeart,
  'md-help-buoy': mdHelpBuoy,
  'md-help-circle-outline': mdHelpCircleOutline,
  'md-help-circle': mdHelpCircle,
  'md-help': mdHelp,
  'md-home': mdHome,
  'md-hourglass': mdHourglass,
  'md-ice-cream': mdIceCream,
  'md-image': mdImage,
  'md-images': mdImages,
  'md-infinite': mdInfinite,
  'md-information-circle-outline': mdInformationCircleOutline,
  'md-information-circle': mdInformationCircle,
  'md-information': mdInformation,
  'md-jet': mdJet,
  'md-journal': mdJournal,
  'md-key': mdKey,
  'md-keypad': mdKeypad,
  'md-laptop': mdLaptop,
  'md-leaf': mdLeaf,
  'md-link': mdLink,
  'md-list-box': mdListBox,
  'md-list': mdList,
  'md-locate': mdLocate,
  'md-lock': mdLock,
  'md-log-in': mdLogIn,
  'md-log-out': mdLogOut,
  'md-magnet': mdMagnet,
  'md-mail-open': mdMailOpen,
  'md-mail-unread': mdMailUnread,
  'md-mail': mdMail,
  'md-male': mdMale,
  'md-man': mdMan,
  'md-map': mdMap,
  'md-medal': mdMedal,
  'md-medical': mdMedical,
  'md-medkit': mdMedkit,
  'md-megaphone': mdMegaphone,
  'md-menu': mdMenu,
  'md-mic-off': mdMicOff,
  'md-mic': mdMic,
  'md-microphone': mdMicrophone,
  'md-moon': mdMoon,
  'md-more': mdMore,
  'md-move': mdMove,
  'md-musical-note': mdMusicalNote,
  'md-musical-notes': mdMusicalNotes,
  'md-navigate': mdNavigate,
  'md-notifications-off': mdNotificationsOff,
  'md-notifications-outline': mdNotificationsOutline,
  'md-notifications': mdNotifications,
  'md-nuclear': mdNuclear,
  'md-nutrition': mdNutrition,
  'md-open': mdOpen,
  'md-options': mdOptions,
  'md-outlet': mdOutlet,
  'md-paper-plane': mdPaperPlane,
  'md-paper': mdPaper,
  'md-partly-sunny': mdPartlySunny,
  'md-pause': mdPause,
  'md-paw': mdPaw,
  'md-people': mdPeople,
  'md-person-add': mdPersonAdd,
  'md-person': mdPerson,
  'md-phone-landscape': mdPhoneLandscape,
  'md-phone-portrait': mdPhonePortrait,
  'md-photos': mdPhotos,
  'md-pie': mdPie,
  'md-pin': mdPin,
  'md-pint': mdPint,
  'md-pizza': mdPizza,
  'md-planet': mdPlanet,
  'md-play-circle': mdPlayCircle,
  'md-play': mdPlay,
  'md-podium': mdPodium,
  'md-power': mdPower,
  'md-pricetag': mdPricetag,
  'md-pricetags': mdPricetags,
  'md-print': mdPrint,
  'md-pulse': mdPulse,
  'md-qr-scanner': mdQrScanner,
  'md-quote': mdQuote,
  'md-radio-button-off': mdRadioButtonOff,
  'md-radio-button-on': mdRadioButtonOn,
  'md-radio': mdRadio,
  'md-rainy': mdRainy,
  'md-recording': mdRecording,
  'md-redo': mdRedo,
  'md-refresh-circle': mdRefreshCircle,
  'md-refresh': mdRefresh,
  'md-remove-circle-outline': mdRemoveCircleOutline,
  'md-remove-circle': mdRemoveCircle,
  'md-remove': mdRemove,
  'md-reorder': mdReorder,
  'md-repeat': mdRepeat,
  'md-resize': mdResize,
  'md-restaurant': mdRestaurant,
  'md-return-left': mdReturnLeft,
  'md-return-right': mdReturnRight,
  'md-reverse-camera': mdReverseCamera,
  'md-rewind': mdRewind,
  'md-ribbon': mdRibbon,
  'md-rocket': mdRocket,
  'md-rose': mdRose,
  'md-sad': mdSad,
  'md-save': mdSave,
  'md-school': mdSchool,
  'md-search': mdSearch,
  'md-send': mdSend,
  'md-settings': mdSettings,
  'md-share-alt': mdShareAlt,
  'md-share': mdShare,
  'md-shirt': mdShirt,
  'md-shuffle': mdShuffle,
  'md-skip-backward': mdSkipBackward,
  'md-skip-forward': mdSkipForward,
  'md-snow': mdSnow,
  'md-speedometer': mdSpeedometer,
  'md-square-outline': mdSquareOutline,
  'md-square': mdSquare,
  'md-star-half': mdStarHalf,
  'md-star-outline': mdStarOutline,
  'md-star': mdStar,
  'md-stats': mdStats,
  'md-stopwatch': mdStopwatch,
  'md-subway': mdSubway,
  'md-sunny': mdSunny,
  'md-swap': mdSwap,
  'md-switch': mdSwitch,
  'md-sync': mdSync,
  'md-tablet-landscape': mdTabletLandscape,
  'md-tablet-portrait': mdTabletPortrait,
  'md-tennisball': mdTennisball,
  'md-text': mdText,
  'md-thermometer': mdThermometer,
  'md-thumbs-down': mdThumbsDown,
  'md-thumbs-up': mdThumbsUp,
  'md-thunderstorm': mdThunderstorm,
  'md-time': mdTime,
  'md-timer': mdTimer,
  'md-today': mdToday,
  'md-train': mdTrain,
  'md-transgender': mdTransgender,
  'md-trash': mdTrash,
  'md-trending-down': mdTrendingDown,
  'md-trending-up': mdTrendingUp,
  'md-trophy': mdTrophy,
  'md-tv': mdTv,
  'md-umbrella': mdUmbrella,
  'md-undo': mdUndo,
  'md-unlock': mdUnlock,
  'md-videocam': mdVideocam,
  'md-volume-high': mdVolumeHigh,
  'md-volume-low': mdVolumeLow,
  'md-volume-mute': mdVolumeMute,
  'md-volume-off': mdVolumeOff,
  'md-walk': mdWalk,
  'md-wallet': mdWallet,
  'md-warning': mdWarning,
  'md-watch': mdWatch,
  'md-water': mdWater,
  'md-wifi': mdWifi,
  'md-wine': mdWine,
  'md-woman': mdWoman
};

export { iosAddCircleOutline, iosAddCircle, iosAdd, iosAirplane, iosAlarm, iosAlbums, iosAlert, iosAmericanFootball, iosAnalytics, iosAperture, iosApps, iosAppstore, iosArchive, iosArrowBack, iosArrowDown, iosArrowDropdownCircle, iosArrowDropdown, iosArrowDropleftCircle, iosArrowDropleft, iosArrowDroprightCircle, iosArrowDropright, iosArrowDropupCircle, iosArrowDropup, iosArrowForward, iosArrowRoundBack, iosArrowRoundDown, iosArrowRoundForward, iosArrowRoundUp, iosArrowUp, iosAt, iosAttach, iosBackspace, iosBarcode, iosBaseball, iosBasket, iosBasketball, iosBatteryCharging, iosBatteryDead, iosBatteryFull, iosBeaker, iosBed, iosBeer, iosBicycle, iosBluetooth, iosBoat, iosBody, iosBonfire, iosBook, iosBookmark, iosBookmarks, iosBowtie, iosBriefcase, iosBrowsers, iosBrush, iosBug, iosBuild, iosBulb, iosBus, iosBusiness, iosCafe, iosCalculator, iosCalendar, iosCall, iosCamera, iosCar, iosCard, iosCart, iosCash, iosCellular, iosChatboxes, iosChatbubbles, iosCheckboxOutline, iosCheckbox, iosCheckmarkCircleOutline, iosCheckmarkCircle, iosCheckmark, iosClipboard, iosClock, iosCloseCircleOutline, iosCloseCircle, iosClose, iosCloudCircle, iosCloudDone, iosCloudDownload, iosCloudOutline, iosCloudUpload, iosCloud, iosCloudyNight, iosCloudy, iosCodeDownload, iosCodeWorking, iosCode, iosCog, iosColorFill, iosColorFilter, iosColorPalette, iosColorWand, iosCompass, iosConstruct, iosContact, iosContacts, iosContract, iosContrast, iosCopy, iosCreate, iosCrop, iosCube, iosCut, iosDesktop, iosDisc, iosDocument, iosDoneAll, iosDownload, iosEasel, iosEgg, iosExit, iosExpand, iosEyeOff, iosEye, iosFastforward, iosFemale, iosFiling, iosFilm, iosFingerPrint, iosFitness, iosFlag, iosFlame, iosFlashOff, iosFlash, iosFlashlight, iosFlask, iosFlower, iosFolderOpen, iosFolder, iosFootball, iosFunnel, iosGift, iosGitBranch, iosGitCommit, iosGitCompare, iosGitMerge, iosGitNetwork, iosGitPullRequest, iosGlasses, iosGlobe, iosGrid, iosHammer, iosHand, iosHappy, iosHeadset, iosHeartDislike, iosHeartEmpty, iosHeartHalf, iosHeart, iosHelpBuoy, iosHelpCircleOutline, iosHelpCircle, iosHelp, iosHome, iosHourglass, iosIceCream, iosImage, iosImages, iosInfinite, iosInformationCircleOutline, iosInformationCircle, iosInformation, iosJet, iosJournal, iosKey, iosKeypad, iosLaptop, iosLeaf, iosLink, iosListBox, iosList, iosLocate, iosLock, iosLogIn, iosLogOut, iosMagnet, iosMailOpen, iosMailUnread, iosMail, iosMale, iosMan, iosMap, iosMedal, iosMedical, iosMedkit, iosMegaphone, iosMenu, iosMicOff, iosMic, iosMicrophone, iosMoon, iosMore, iosMove, iosMusicalNote, iosMusicalNotes, iosNavigate, iosNotificationsOff, iosNotificationsOutline, iosNotifications, iosNuclear, iosNutrition, iosOpen, iosOptions, iosOutlet, iosPaperPlane, iosPaper, iosPartlySunny, iosPause, iosPaw, iosPeople, iosPersonAdd, iosPerson, iosPhoneLandscape, iosPhonePortrait, iosPhotos, iosPie, iosPin, iosPint, iosPizza, iosPlanet, iosPlayCircle, iosPlay, iosPodium, iosPower, iosPricetag, iosPricetags, iosPrint, iosPulse, iosQrScanner, iosQuote, iosRadioButtonOff, iosRadioButtonOn, iosRadio, iosRainy, iosRecording, iosRedo, iosRefreshCircle, iosRefresh, iosRemoveCircleOutline, iosRemoveCircle, iosRemove, iosReorder, iosRepeat, iosResize, iosRestaurant, iosReturnLeft, iosReturnRight, iosReverseCamera, iosRewind, iosRibbon, iosRocket, iosRose, iosSad, iosSave, iosSchool, iosSearch, iosSend, iosSettings, iosShareAlt, iosShare, iosShirt, iosShuffle, iosSkipBackward, iosSkipForward, iosSnow, iosSpeedometer, iosSquareOutline, iosSquare, iosStarHalf, iosStarOutline, iosStar, iosStats, iosStopwatch, iosSubway, iosSunny, iosSwap, iosSwitch, iosSync, iosTabletLandscape, iosTabletPortrait, iosTennisball, iosText, iosThermometer, iosThumbsDown, iosThumbsUp, iosThunderstorm, iosTime, iosTimer, iosToday, iosTrain, iosTransgender, iosTrash, iosTrendingDown, iosTrendingUp, iosTrophy, iosTv, iosUmbrella, iosUndo, iosUnlock, iosVideocam, iosVolumeHigh, iosVolumeLow, iosVolumeMute, iosVolumeOff, iosWalk, iosWallet, iosWarning, iosWatch, iosWater, iosWifi, iosWine, iosWoman, logoAndroid, logoAngular, logoApple, logoBitbucket, logoBitcoin, logoBuffer, logoChrome, logoClosedCaptioning, logoCodepen, logoCss3, logoDesignernews, logoDribbble, logoDropbox, logoEuro, logoFacebook, logoFlickr, logoFoursquare, logoFreebsdDevil, logoGameControllerA, logoGameControllerB, logoGithub, logoGoogle, logoGoogleplus, logoHackernews, logoHtml5, logoInstagram, logoIonic, logoIonitron, logoJavascript, logoLinkedin, logoMarkdown, logoModelS, logoNoSmoking, logoNodejs, logoNpm, logoOctocat, logoPinterest, logoPlaystation, logoPolymer, logoPython, logoReddit, logoRss, logoSass, logoSkype, logoSlack, logoSnapchat, logoSteam, logoTumblr, logoTux, logoTwitch, logoTwitter, logoUsd, logoVimeo, logoVk, logoWhatsapp, logoWindows, logoWordpress, logoXbox, logoXing, logoYahoo, logoYen, logoYoutube, mdAddCircleOutline, mdAddCircle, mdAdd, mdAirplane, mdAlarm, mdAlbums, mdAlert, mdAmericanFootball, mdAnalytics, mdAperture, mdApps, mdAppstore, mdArchive, mdArrowBack, mdArrowDown, mdArrowDropdownCircle, mdArrowDropdown, mdArrowDropleftCircle, mdArrowDropleft, mdArrowDroprightCircle, mdArrowDropright, mdArrowDropupCircle, mdArrowDropup, mdArrowForward, mdArrowRoundBack, mdArrowRoundDown, mdArrowRoundForward, mdArrowRoundUp, mdArrowUp, mdAt, mdAttach, mdBackspace, mdBarcode, mdBaseball, mdBasket, mdBasketball, mdBatteryCharging, mdBatteryDead, mdBatteryFull, mdBeaker, mdBed, mdBeer, mdBicycle, mdBluetooth, mdBoat, mdBody, mdBonfire, mdBook, mdBookmark, mdBookmarks, mdBowtie, mdBriefcase, mdBrowsers, mdBrush, mdBug, mdBuild, mdBulb, mdBus, mdBusiness, mdCafe, mdCalculator, mdCalendar, mdCall, mdCamera, mdCar, mdCard, mdCart, mdCash, mdCellular, mdChatboxes, mdChatbubbles, mdCheckboxOutline, mdCheckbox, mdCheckmarkCircleOutline, mdCheckmarkCircle, mdCheckmark, mdClipboard, mdClock, mdCloseCircleOutline, mdCloseCircle, mdClose, mdCloudCircle, mdCloudDone, mdCloudDownload, mdCloudOutline, mdCloudUpload, mdCloud, mdCloudyNight, mdCloudy, mdCodeDownload, mdCodeWorking, mdCode, mdCog, mdColorFill, mdColorFilter, mdColorPalette, mdColorWand, mdCompass, mdConstruct, mdContact, mdContacts, mdContract, mdContrast, mdCopy, mdCreate, mdCrop, mdCube, mdCut, mdDesktop, mdDisc, mdDocument, mdDoneAll, mdDownload, mdEasel, mdEgg, mdExit, mdExpand, mdEyeOff, mdEye, mdFastforward, mdFemale, mdFiling, mdFilm, mdFingerPrint, mdFitness, mdFlag, mdFlame, mdFlashOff, mdFlash, mdFlashlight, mdFlask, mdFlower, mdFolderOpen, mdFolder, mdFootball, mdFunnel, mdGift, mdGitBranch, mdGitCommit, mdGitCompare, mdGitMerge, mdGitNetwork, mdGitPullRequest, mdGlasses, mdGlobe, mdGrid, mdHammer, mdHand, mdHappy, mdHeadset, mdHeartDislike, mdHeartEmpty, mdHeartHalf, mdHeart, mdHelpBuoy, mdHelpCircleOutline, mdHelpCircle, mdHelp, mdHome, mdHourglass, mdIceCream, mdImage, mdImages, mdInfinite, mdInformationCircleOutline, mdInformationCircle, mdInformation, mdJet, mdJournal, mdKey, mdKeypad, mdLaptop, mdLeaf, mdLink, mdListBox, mdList, mdLocate, mdLock, mdLogIn, mdLogOut, mdMagnet, mdMailOpen, mdMailUnread, mdMail, mdMale, mdMan, mdMap, mdMedal, mdMedical, mdMedkit, mdMegaphone, mdMenu, mdMicOff, mdMic, mdMicrophone, mdMoon, mdMore, mdMove, mdMusicalNote, mdMusicalNotes, mdNavigate, mdNotificationsOff, mdNotificationsOutline, mdNotifications, mdNuclear, mdNutrition, mdOpen, mdOptions, mdOutlet, mdPaperPlane, mdPaper, mdPartlySunny, mdPause, mdPaw, mdPeople, mdPersonAdd, mdPerson, mdPhoneLandscape, mdPhonePortrait, mdPhotos, mdPie, mdPin, mdPint, mdPizza, mdPlanet, mdPlayCircle, mdPlay, mdPodium, mdPower, mdPricetag, mdPricetags, mdPrint, mdPulse, mdQrScanner, mdQuote, mdRadioButtonOff, mdRadioButtonOn, mdRadio, mdRainy, mdRecording, mdRedo, mdRefreshCircle, mdRefresh, mdRemoveCircleOutline, mdRemoveCircle, mdRemove, mdReorder, mdRepeat, mdResize, mdRestaurant, mdReturnLeft, mdReturnRight, mdReverseCamera, mdRewind, mdRibbon, mdRocket, mdRose, mdSad, mdSave, mdSchool, mdSearch, mdSend, mdSettings, mdShareAlt, mdShare, mdShirt, mdShuffle, mdSkipBackward, mdSkipForward, mdSnow, mdSpeedometer, mdSquareOutline, mdSquare, mdStarHalf, mdStarOutline, mdStar, mdStats, mdStopwatch, mdSubway, mdSunny, mdSwap, mdSwitch, mdSync, mdTabletLandscape, mdTabletPortrait, mdTennisball, mdText, mdThermometer, mdThumbsDown, mdThumbsUp, mdThunderstorm, mdTime, mdTimer, mdToday, mdTrain, mdTransgender, mdTrash, mdTrendingDown, mdTrendingUp, mdTrophy, mdTv, mdUmbrella, mdUndo, mdUnlock, mdVideocam, mdVolumeHigh, mdVolumeLow, mdVolumeMute, mdVolumeOff, mdWalk, mdWallet, mdWarning, mdWatch, mdWater, mdWifi, mdWine, mdWoman };



// WEBPACK FOOTER //
// ./src/lib/ionicons/dist/collection/icon/svg/index.esm.js